/**
 * Solihull Registration Service terms and conditions, per venue (carried over
 * from the Gen-1 app). Shown on the summary page when the JRNI parent company
 * carries no `terms_and_conditions` extra field.
 */
export const SOLIHULL_TERMS_HTML = `Please read the relevant Solihull Registration Service Terms and Conditions and confirm you agree. <br/> <br/>
<ul>
<li><a target="_blank" rel="noopener" href="https://res.cloudinary.com/bookinglab/image/upload/v1745921919/SolihullRegisterOffice_Solihull_2025_xy354o.pdf">Solihull Register Office</a></li>
<li><a target="_blank" rel="noopener" href="https://res.cloudinary.com/bookinglab/image/upload/v1745921919/TheCeremonySuite_Solihull_2025_cxu89u.pdf">The Ceremony Suite</a></li>
<li><a target="_blank" rel="noopener" href="https://res.cloudinary.com/bookinglab/image/upload/v1745921920/JubileeRoom_Solihull_2025_ls2hxg.pdf">Jubilee Room</a></li>
<li><a target="_blank" rel="noopener" href="https://res.cloudinary.com/bookinglab/image/upload/v1745921919/LicensedVenue_Solihull_2025_bltgxg.pdf">Licensed Venue</a></li>
</ul>`;

export const SOLIHULL_CITIZENSHIP_TERMS_HTML = `Please read the relevant Solihull Registration Service Terms and Conditions and confirm you agree. <br/> <br/>
<ul>
<li><a target="_blank" rel="noopener" href="https://res.cloudinary.com/bookinglab/image/upload/v1745921919/PrivateBritishCitizenshipCeremony_Solihull_2025_pxyxt1.pdf">Private Citizenship Ceremony</a></li>
</ul>`;

/** JRNI service ids (parent company 37016) that are citizenship ceremonies. */
export const SOLIHULL_CITIZENSHIP_SERVICE_IDS = [48430, 48431];

export function solihullTermsFor(serviceId: number | string | undefined): string {
	return SOLIHULL_CITIZENSHIP_SERVICE_IDS.includes(Number(serviceId))
		? SOLIHULL_CITIZENSHIP_TERMS_HTML
		: SOLIHULL_TERMS_HTML;
}

/**
 * Shown above the privacy-statement checkbox when the JRNI department carries
 * no `privacy_statement_text`. Retention wording matches the Gen-1 app.
 */
export const SOLIHULL_PRIVACY_HTML = `Registration information is retained indefinitely as required by law. Information collected during the booking of appointments and ceremonies, including certificate orders, is retained for 2 years from the date of the appointment or ceremony. See the council's <a href="https://www.solihull.gov.uk/privacy" target="_blank" rel="noopener">privacy notice</a> for how your information is processed.`;
